export class KonvaComponentBase {
    /**
    * @protected
    * @type {Konva.Stage}
    */
    stage;

    /**
    * @protected
    * @type {number}
    */
    pageScale = 1;

    /**
     * @protected
     * @type {Konva.Layer}
     */
    mainLayer;

    /**
     * Referencja do skorelowanego obiektu w C#
     * @protected
     */
    dotNetReference;

    /**
     * @protected
     * @type {Guid}
     * Wskazuje na element DOM, na którym zamontowana jest scena Konvy
     */
    domElementUid;

    /**
     * @protected
     * @type {Function}
     * Przechowuje referencję funkcji resizeStage dla danego obiektu.
     *
     */
    resizeFunRef;

    /**
     * @protected
     * @type {Function}
     * Przechowuje referencję do aktualnej funkcji obsługi kliknięcia w danym trybie.
     *
     */
    clickFunRef;

    /**
    * @protected
    * @type {string}
    * Podstawowy prompt dla textboxów
    */
    defaultPromptText;

    // #region Object maintenance
    constructor(dotNetReference, domElementUid, defaultPromptText) {
        this.dotNetReference = dotNetReference;
        this.domElementUid = domElementUid;
        this.defaultPromptText = defaultPromptText || "Text";
    }
    dispose() {
        if (this.resizeFunRef) // sprawdzamy czy był podpinany listener
            window.removeEventListener("resize", this.resizeFunRef);
        this.resizeFunRef = null;
        this.clickFunRef = null;
        this.dotNetReference = null;
        if (this.stage) {
            this.stage.destroy();
            this.stage = null;
            this.mainLayer = null;
            this.pageScale = 1;
        }
    }
    // #endregion
    resizeStage() {
        if (!this.stage) return;
        const actualWidth = document.getElementById(this.domElementUid).clientWidth;
        const actualHeight = document.getElementById(this.domElementUid).clientHeight;
        // Calculate actual stage size
        const actualStageWidth = this.stage.width() / this.pageScale;
        const actualStageHeight = this.stage.height() / this.pageScale;

        // Calculate scale factors
        const scaleX = actualWidth / actualStageWidth;
        const scaleY = actualHeight / actualStageHeight;
        this.pageScale = Math.min(scaleX, scaleY);

        // Set new stage size
        this.stage.width(actualStageWidth * this.pageScale);
        this.stage.height(actualStageHeight * this.pageScale);

        // Scale the stage
        this.stage.scale({ x: this.pageScale, y: this.pageScale });

        // Redraw the mainLayer  
        this.stage.batchDraw();
    }
}